import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { APP_ID, PACKAGE_NAME } from './model/constants';
import rootEpic from './ops';
import createStore from './state';
import { initializeContext } from './state/context/actions';
import type { ContextState } from './state/context/types';
import {
	fetchInstanceProperties,
	fetchProjectCategories,
	fetchProjectDetails,
} from './state/entities/actions';
import type { AppState } from './state/types';
import View from './view';

export type Props = ContextState;

// eslint-disable-next-line jira/react/no-class-components
class App extends Component<Props> {
	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic);
		this.store.dispatch(initializeContext(this.props));
		this.store.dispatch(fetchProjectDetails());
		this.store.dispatch(fetchProjectCategories());
		this.store.dispatch(fetchInstanceProperties());
	}

	store: Store<AppState>;

	render() {
		return (
			<AppBase id={APP_ID} store={this.store}>
				<ReportErrors
					id="unhandled"
					packageName={PACKAGE_NAME}
					teamName="helix"
					sendToPrivacyUnsafeSplunk
				>
					<AppStyle>
						<View />
					</AppStyle>
				</ReportErrors>
			</AppBase>
		);
	}
}
export { App as ProjectDetailsApp };

export default App;
